import gql from 'graphql-tag'
import { DealFragment } from '@/graphql/fragments/crm'

export const query = gql`
  ${DealFragment}
  query findDeal($filter: crm_deal_bool_exp) {
    records: crm_deal(where: $filter) {
      ...Deal
      stock{
        id
      }
    }
  }
`

export default query
